class Never {}

export const ImageData = globalThis.ImageData || /** @type {typeof ImageData} */(Never);
